import {NgModule} from '@angular/core';
import {TagsComponent} from './directive/tags/tags.component';
import {CommentsComponent} from './directive/comments/comments.component';
import {UmConfigPage} from "./page/overview/config/um-config.page";
import {
    UmRoleObjectComponent
} from "./component/protected-components/object/um-role-object-component/um-role-object.component";
import {UserProfileComponent} from "./component/protected-components/user-profile/user-profile.component";
import {ImageCropperModule} from "ngx-image-cropper";
import {UserProfileIdComponent} from "./component/protected-components/user-profile-id/user-profile-id.component";
import {UserOverviewPage} from "./page/user-overview-page/user-overview.page";
import {UmKpiComponent} from "./page/user-overview-page/components/kpiComponent/um-kpi.component";
import {UmStatisticsComponent} from "./page/user-overview-page/components/statisticsComponent/um-statistics.component";
import {
    UmRoleObjectFullComponent
} from "./component/protected-components/object/um-role-object-component/view/um-role-object-full/um-role-object-full.component";
import {
    UmRoleObjectSideComponent
} from "./component/protected-components/object/um-role-object-component/view/um-role-object-side/um-role-object-side.component";
import {
    UmRoleObjectBaseComponent
} from "./component/protected-components/object/um-role-object-component/view/um-role-object-base.component";
import {UserCalendarComponent} from "./component/protected-components/user-calendar-component/user-calendar.component";
import {UM_ENTITY_PROVIDER} from "./um.entity-provider";
import {CoreModule} from "../../core/core.module";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {UiModule} from "../../core/ui/ui.module";
import {PMessagesComponent} from "../../core/shared/p-messages/p-messages.component";
import {UM_TEST_PROVIDERS} from "./test/um-test-definition";


@NgModule({
    declarations: [
        TagsComponent,
        CommentsComponent,
        UmConfigPage,
        UmRoleObjectComponent,
        UserProfileComponent,
        UserProfileIdComponent,
        UserOverviewPage,
        UmKpiComponent,
        UmStatisticsComponent,
        UmRoleObjectFullComponent,
        UmRoleObjectSideComponent,
        UmRoleObjectBaseComponent,
        UserCalendarComponent
    ],
    exports: [
        TagsComponent,
        CommentsComponent,
        UmConfigPage,
        UmRoleObjectComponent,
        UserProfileComponent,
        UserProfileIdComponent,
        UmRoleObjectFullComponent,
        UmRoleObjectSideComponent,
        UmRoleObjectBaseComponent,
        UserCalendarComponent,

    ],
    imports: [
        CoreModule,
        ImageCropperModule,
        UiModule,
        PMessagesComponent,
    ],
    providers: [UM_ENTITY_PROVIDER, UM_TEST_PROVIDERS]
})
export class UmModule implements DynamicModule {

    alias = 'um';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return UmKpiComponent;
    }

    getStatisticsComponent() {
        return UmStatisticsComponent;
    }

}

